import { Badge, Box } from '@chakra-ui/react'
import { EncounterType } from '@hb/shared'
import { FC } from 'react'
import { EncounterTypeHeaderContentProps } from '../types'

export const AntepartumExamHeaderContent: FC<
  EncounterTypeHeaderContentProps<EncounterType.ANTEPARTUM>
> = ({ config }) => {
  if (!config) return null
  return (
    <Box>
      {/* Routine chip — sage on light sage, pill (spec 0.6.1 "Active chip"). */}
      <Badge
        fontSize="10px"
        fontWeight={500}
        fontFamily="Hero-New"
        color="#4a7c59"
        bg="#eaf3de"
        borderRadius="full"
        px={2}
        py="3px">
        {config.visitType === 'routine' ? 'Routine' : 'Non-Routine'}
      </Badge>
    </Box>
  )
}
